import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import {
  Drawer,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
  Divider,
  List,
  Tooltip,
  useMediaQuery,
  Icon,
} from '@material-ui/core';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import { HeartPulse, AccountMultiple, FileDocumentOutline, CertificateOutline } from 'mdi-material-ui';
import clsx from 'clsx';
import { ACCREDITEDS_ROUTE, FORMS_ROUTE, PATIENTS_ROUTE, USERS_ROUTE } from '../../constants';
import { useStyles } from './styles';

type SidebarProps = {
  isDrawerOpen?: boolean;
  onDrawerClose?: () => void;
};

export default function Sidebar({ isDrawerOpen, onDrawerClose }: SidebarProps): JSX.Element {
  const classes = useStyles();
  const theme = useTheme();
  const isXS = useMediaQuery(theme.breakpoints.down('xs'));
  const { pathname } = useLocation();

  const token = localStorage.getItem('admToken');
  
  const userRole = token ? jwt_decode(token).type : null;

  return (
    <Drawer
      variant={isXS ? 'temporary' : 'permanent'}
      open={isDrawerOpen}
      ModalProps={{
        keepMounted: true,
      }}
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: isDrawerOpen,
        [classes.drawerClose]: !isDrawerOpen,
      })}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: isDrawerOpen,
          [classes.drawerClose]: !isDrawerOpen,
        }),
      }}
    >
      <div className={classes.toolbar}>
        <IconButton onClick={onDrawerClose}>
          {theme.direction === 'rtl' ? <ChevronRight /> : <ChevronLeft />}
        </IconButton>
      </div>
      <Divider />
      <List>
        {userRole === 'ADMIN' && (
          <Tooltip title={'Usuários'} placement="right" arrow disableHoverListener={isDrawerOpen}>
          <ListItem
            button
            className={classes.drawerListItem}
            component={Link}
            to={USERS_ROUTE}
          >
            <ListItemIcon>
              <AccountMultiple color={pathname === USERS_ROUTE ? 'primary' : 'inherit'} />
              <Icon color={pathname === USERS_ROUTE ? 'primary' : 'inherit'} />
            </ListItemIcon>
            <ListItemText
              primary='Usuários'
              hidden={!isDrawerOpen}
              primaryTypographyProps={{ color: pathname === USERS_ROUTE ? 'primary' : 'inherit' }}
            />
          </ListItem>
        </Tooltip>        
        )}
        <Tooltip title={'Pacientes'} placement="right" arrow disableHoverListener={isDrawerOpen}>
          <ListItem button className={classes.drawerListItem} component={Link} to={PATIENTS_ROUTE}>
            <ListItemIcon>
              <HeartPulse color={pathname === PATIENTS_ROUTE ? 'primary' : 'inherit'} />
              <Icon color={pathname === PATIENTS_ROUTE ? 'primary' : 'inherit'} />
            </ListItemIcon>
            <ListItemText
              primary='Pacientes'
              hidden={!isDrawerOpen}
              primaryTypographyProps={{ color: pathname === PATIENTS_ROUTE ? 'primary' : 'inherit' }}
            />
          </ListItem>
        </Tooltip>
        <Tooltip title={'Consentimentos'} placement="right" arrow disableHoverListener={isDrawerOpen}>
          <ListItem button className={classes.drawerListItem} component={Link} to={FORMS_ROUTE}>
            <ListItemIcon>
              <FileDocumentOutline color={pathname === FORMS_ROUTE ? 'primary' : 'inherit'} />
              <Icon color={pathname === FORMS_ROUTE ? 'primary' : 'inherit'} />
            </ListItemIcon>
            <ListItemText
              primary='Consentimentos'
              hidden={!isDrawerOpen}
              primaryTypographyProps={{ color: pathname === FORMS_ROUTE ? 'primary' : 'inherit' }}
            />
          </ListItem>
        </Tooltip>
        {userRole === 'ADMIN' && (
          <Tooltip title={'Credenciados'} placement="right" arrow disableHoverListener={isDrawerOpen}>
            <ListItem
              button
              className={classes.drawerListItem}
              component={Link}
              to={ACCREDITEDS_ROUTE}
            >
              <ListItemIcon>
                <CertificateOutline color={pathname === ACCREDITEDS_ROUTE ? 'primary' : 'inherit'} />
                <Icon color={pathname === ACCREDITEDS_ROUTE ? 'primary' : 'inherit'} />
              </ListItemIcon>
              <ListItemText
                primary='Credenciados'
                hidden={!isDrawerOpen}
                primaryTypographyProps={{ color: pathname === ACCREDITEDS_ROUTE ? 'primary' : 'inherit' }}
              />
            </ListItem>
          </Tooltip>
        )}
      </List>
      <Divider />
    </Drawer>
  );
}
